module.exports = __webpack_public_path__ + "img/graden1.ed935437.png";